import { render, staticRenderFns } from "./SocioeconomicaPage.vue?vue&type=template&id=f551f5fa&scoped=true&"
import script from "./SocioeconomicaPage.vue?vue&type=script&lang=js&"
export * from "./SocioeconomicaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f551f5fa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/SocioeconomicaPage.vue
// module id = 219
// module chunks = 5